import axios from 'axios';
import { SERVER_URL } from 'Constants';

const USER_TYPE_REQUEST_API_URL = `${SERVER_URL}/api/user-display-name-requests`;

export interface CreateUserTypeRequestPayload {
	/** The customer the request is about. Omit to request for the logged-in user themselves. */
	userId?: string;
	userDisplayNameId: string;
	message?: string;
}

export interface UserTypeRequestResult {
	requestId: string;
	status: string;
	alreadyPending: boolean;
	receiversNotified: number;
}

export interface PendingUserTypeRequest {
	id: string;
	userDisplayNameId: string;
	userDisplayName: string;
	created: string;
}

export async function createUserTypeRequest(payload: CreateUserTypeRequestPayload): Promise<UserTypeRequestResult> {
	const { data } = await axios.post<UserTypeRequestResult>(USER_TYPE_REQUEST_API_URL, payload);
	return data;
}

/**
 * The pending user type requests for a user. userId omitted = the logged-in user; passing
 * another user's id requires a staff role server-side.
 */
export async function fetchPendingUserTypeRequests(userId?: string): Promise<PendingUserTypeRequest[]> {
	const { data } = await axios.get<PendingUserTypeRequest[]>(`${USER_TYPE_REQUEST_API_URL}/pending`, {
		params: { userId: userId || undefined },
	});
	return data ?? [];
}

export interface ResolveUserTypeRequestResult {
	id: string;
	status: string;
}

/**
 * Withdraws a pending request — allowed for the customer it's about, its submitter, or staff.
 */
export async function cancelUserTypeRequest(requestId: string): Promise<ResolveUserTypeRequestResult> {
	const { data } = await axios.post<ResolveUserTypeRequestResult>(`${USER_TYPE_REQUEST_API_URL}/${requestId}/cancel`);
	return data;
}

/**
 * Rejects a pending request — manager+ only.
 */
export async function rejectUserTypeRequest(requestId: string): Promise<ResolveUserTypeRequestResult> {
	const { data } = await axios.post<ResolveUserTypeRequestResult>(`${USER_TYPE_REQUEST_API_URL}/${requestId}/reject`);
	return data;
}

/**
 * Accepts a pending request — manager+ only. The server assigns the requested type to the
 * account (including the matching role swap) and marks the request fulfilled.
 */
export async function acceptUserTypeRequest(requestId: string): Promise<ResolveUserTypeRequestResult> {
	const { data } = await axios.post<ResolveUserTypeRequestResult>(`${USER_TYPE_REQUEST_API_URL}/${requestId}/accept`);
	return data;
}
